<div class="input-group campanha-multiselect">
    <div class="input-group-prepend">
        <button class="btn btn-light" type="button" data-toggle="dropdown" aria-expanded="false">
            <i class="fas fa-cog"></i>
        </button>
        <div class="dropdown-menu">
            <div class="dropdown-item" onclick="event.stopPropagation()">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [ngModel]="somenteEmAndamento" (ngModelChange)="toggleSomenteEmAndamento($event)" [name]="nameSomenteEmAndamento" [id]="idSomenteEmAndamento">
                    <label class="custom-control-label" [for]="idSomenteEmAndamento"> Somente Em Andamento</label>
                </div>
            </div>
        </div>
    </div>
    <ngx-bootstrap-multiselect
        [settings]="settings"
        [texts]="texts"
        [options]="options"
        [(ngModel)]="idsCampanhas"
        (ngModelChange)="onChange()"
        [disabled]="disabled">
    </ngx-bootstrap-multiselect>
</div>